import { IColumnHookInput, IColumnHookOutput } from 'dromo-uploader-react'

export function validateNumbers(
  values: IColumnHookInput[]
): IColumnHookOutput[] {
  return values.map((row) => {
    const parsed = parseFloat(String(row.value))
    // Return the row unchanged if its value is numeric
    if (!isNaN(parsed)) {
      return row
    }

    const rowOutput: IColumnHookOutput = {
      index: row.index,
      value: null,
    }
    return rowOutput
  })
}
